import React, {Component, Fragment} from 'react';
import {Route} from "react-router-dom";
import Async from "react-code-splitting";

const Home = /* istanbul ignore next */ () => <Async load={import("./Home/Home")}/>;
const Auth = /* istanbul ignore next */ () => <Async load={import("./Auth/Auth")}/>;
const CreateProblem = /* istanbul ignore next */ () => <Async load={import("./Problem/CreateProblem")}/>;
const ViewProblem = /* istanbul ignore next */ props => <Async load={import("./Problem/ViewProblem")}
                                                               componentProps={props}/>;
const Tenders = () => <Async load={import("./Tender/Tenders")}/>;
const Tender = () => <Async load={import("./Tender/Tender")}/>;

const Map = () => <Async load={import("./Map/Map")}/>;
const Problem = () => <Async load={import("./Problem/Problem")}/>;
const CityObject = () => <Async load={import("./Object/CityObject")}/>;

const Article = () => <Async load={import("./Article/Article")}/>;

export default class Public extends Component {
    render() {
        return (
            <Fragment>
                <Route exact path="/" component={Home}/>
                <Route exact path="/auth" component={Auth}/>
                <Route exact path="/add" component={CreateProblem}/>
                <Route exact path="/mv/:uid" component={ViewProblem}/>
                <Route exact path="/tenders" component={Tenders}/>
                <Route exact path="/tenders/:id" component={Tender}/>
                <Route exact path="/map" component={Map}/>
                <Route exact path="/problems/:id" component={Problem}/>
                <Route exact path="/objects/:id" component={CityObject}/>
                <Route exact path="/cookie_policy" component={Article}/>
            </Fragment>
        );
    }
}
